// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'

const serveName = process.env.VUE_APP_SERVENAME

const sandboxServeName = 'PaySandbox'

// 商品配置
// 同步线上商品
export const syncProductFetch = (data?: object) => request(`/${serveName}/product/syncProduct`, null, 'POST_JSON', data)

// 场景配置
// 获取场景分类列表
export const getScenarioListFetch = (data?: object) =>
  request(`/${sandboxServeName}/scenario/getScenarioList`, null, 'POST_JSON', data)

// 获取场景子分类[场景管理]列表
export const getSubScenarioListFetch = (data?: object) =>
  request(`/${sandboxServeName}/scenario/getSubScenarioList`, null, 'POST_JSON', data)

// 新增/修改场景子分类
export const addSubScenarioFetch = (data?: object) =>
  request(`/${sandboxServeName}/scenario/addSubScenario`, null, 'POST_JSON', data)

// 删除测试子场景
export const deleteSubScenarioFetch = (data?: object) =>
  request(`/${sandboxServeName}/scenario/deleteSubScenario`, null, 'POST_JSON', data)

// 测试配置
// 通过dbtId查询沙盒测试设备
export const getTestDeviceListFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/getTestDeviceList`, null, 'POST_JSON', data)

// 新增沙盒测试设备
export const addTestDeviceFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/addTestDevice`, null, 'POST_JSON', data)

// 删除沙盒测试设备
export const deleteTestDeviceFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/deleteTestDevice`, null, 'POST_JSON', data)

// 查询测试配置
export const getTestConfigListFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/getTestConfigList`, null, 'POST_JSON', data)

// 新增/修改测试配置
export const addTestConfigFetch = (data?: object) =>
  request(`/${sandboxServeName}/testConfig/addTestConfig`, null, 'POST_JSON', data)

// MOCK订单查询
export const getMockOrderListFetch = (data?: object) =>
  request(`/${sandboxServeName}/thirdOrder/getOrderList`, null, 'POST_JSON', data)
